import React from "react";
import PropTypes from "prop-types";

export default function TemplatePreview({ selectedTemplate }) {
  if (!selectedTemplate) return null;

  return (
    <div className="flex flex-col gap-8 w-full items-center">
      {selectedTemplate.images.map((img, i) => (
        <div
          key={i}
          className="w-full max-w-[720px] aspect-video bg-white  overflow-hidden border border-gray-200 shadow-sm"
        >
          <img
            src={img}
            alt={`Slide ${i + 1}`}
            className="w-full h-full object-cover"
          />
        </div>
      ))}
    </div>
  );
}

TemplatePreview.propTypes = {
  selectedTemplate: PropTypes.object,
};
